import React from 'react';
import { Link } from 'framework7-react';

interface IlinkProps {
  className?: any; // set class which is conditional
  children?: any; // set any control which is conditional
  popupOpen?: string; // set property which is conditional
  popupClose?: any; // set property which is conditional
  href?: any; // set href which is conditional
  onclickEvent? : (arg: any,id?:string) => void; // set onclick which is conditional
  style? : any; // set style of link which is conditional
  tabLink?: string; // set tablink from profile menubar
  tabLinkActive?: any; // set Active tab link from profile menubar
  text?: string; // set text for link
  target?: any;
  id?: any;
  role?: string;
  'aria-selected'?: boolean;
  'aria-controls'?: string;
  'aria-label'?: string;
  onKeyDown?: (e: any) => void; // set keydown handler which is conditional
}

const Ylink: React.FC<IlinkProps> = ({
  className,
  popupOpen,
  children,
  popupClose,
  href,
  onclickEvent,
  style,
  tabLink,
  tabLinkActive,
  text,
  target,
  id,
  role,
  'aria-selected': ariaSelected,
  'aria-controls': ariaControls,
  'aria-label': ariaLabel,
  onKeyDown,
}) => {
  const ariaProps: Record<string, any> = {};
  if (role) ariaProps['role'] = role;
  if (ariaSelected !== undefined) ariaProps['aria-selected'] = ariaSelected;
  if (ariaControls) ariaProps['aria-controls'] = ariaControls;
  if (ariaLabel) ariaProps['aria-label'] = ariaLabel;
  if (onKeyDown) ariaProps['onKeyDown'] = onKeyDown;

  return (
    <Link
      className={className}
      popupOpen={popupOpen}
      popupClose={popupClose}
      href={href}
      onClick={onclickEvent}
      style={style}
      tabLink={tabLink}
      tabLinkActive={tabLinkActive}
      text={text}
      target={target}
      id={id}
      {...ariaProps}
    >
      {children}
    </Link>
  );
};

export default Ylink;
